export default __webpack_public_path__ + "static/tshirt-5c208d1c32c9aacb5ee7577f9eada5b4.jpg";